// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"15b1e593","453":"0abd2be3"}[chunkId] + ".chunk.js";
};